module.exports = __webpack_public_path__ + "b5cfa1e609190cb4bf3f5d67510085db.svg";